// extracted by mini-css-extract-plugin
export var truncate = "_e-0";